
export const zhCNTranslations = {
  'nav.home': '首页',
  'nav.products': 'eSIM',
  'nav.contact': '联系我们',
  'product.customize': '定制',
  'product.price_oriented': '价格优先',
  'product.quality_oriented': '质量优先',
  'product.specs': '规格',
  'product.usage_days': '使用天数',
  'product.day': '天',
  'product.gb_per_day': '每天GB',
  'product.unlimited': '无限流量',
  'checkout.title': '结账',
  'checkout.email': '电子邮件',
  'checkout.card_info': '卡信息',
  'checkout.card_number': '卡号',
  'checkout.expiry_date': '有效期',
  'checkout.cvc': '安全码',
  'checkout.pay': '立即支付',
  'checkout.total': '总计',
  'checkout.tax': '含税',
  'checkout.terms': '我同意服务条款',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',
  'footer.company': '关于我们',
  'footer.law': '特定商业交易法',
  'footer.copyright_tomaruyo': '© {year} TomaRuyo 版权所有。',
  // New translations
  'hero.title': '在日本使用的实惠eSIM',
  'hero.subtitle': '畅享舒适住宿和流畅的网络连接。使用我们的原创eSIM分享您的旅行记忆。',
  'hero.apa.title': '获取在日本使用的实惠eSIM',
  'hero.apa.subtitle': '畅享舒适住宿和流畅的网络连接。通过APA酒店的原创数据套餐，让商务和休闲更加便捷。',
  'products.title': 'eSIM套餐',
  'products.subtitle': '您可以选择最喜欢的通讯套餐。从注重价格的经济套餐到提供高质量通讯环境的优质套餐，我们都有提供。',
  'products.all': '全部',
  'products.price_focus': '注重价格',
  'products.quality': '注重质量',
  'products.choose_plan': '选择此套餐',
  'products.selected': '已选择',
  'customization.days': '天',
  'customization.back': '返回',
  'checkout.payment_info': '支付信息',
  'checkout.secure_payment': '通过Stripe安全支付',
  'checkout.order_summary': '订单摘要',
  'checkout.plan': '套餐：',
  'checkout.data_amount': '数据流量：',
  'checkout.network': '网络：',
  'checkout.usage_days': '使用天数：',
  'checkout.base_fee': '基本费用：',
  'checkout.days_fee': '每日费用：',
  'checkout.processing': '处理中...',
  'checkout.privacy_policy': '隐私政策',
  'checkout.agree': '我同意',
  'thankyou.title': '感谢您的订购！',
  'thankyou.message': '我们已将确认邮件发送至 {email}。您将在24小时内收到您的eSIM信息。',
  'thankyou.next_steps': '下一步',
  'thankyou.step1': '1. 检查您的邮箱',
  'thankyou.step2': '2. 您将收到订单确认邮件',
  'thankyou.step3': '3. eSIM信息将在24小时内发送',
  'thankyou.back_to_home': '返回主页',
  'thankyou.official_site': '前往Super Hotel官方网站',
  'thankyou.rb_official_site': '前往R&B Hotel官方网站',
  'thankyou.apa_official_site': '前往APA Hotel官方网站',
  'footer.links': '链接',
  'footer.official_website': '官方网站',
  'footer.hotel_list': '酒店列表',
  'footer.campaigns': '活动',
  'footer.stay_plans': '住宿套餐',
  'footer.information': '信息',
  'footer.copyright': '© {year} Super Hotel Co., Ltd. 版权所有。',
  'footer.rb_copyright': '© {year} R&B Hotel. 版权所有。',
  'footer.apa_copyright': '© {year} APA HOTEL Co., Ltd. 版权所有。',
  'hero.choose_esim': '选择eSIM',
  'hero.learn_more': '了解更多',
  
  // New translations for the updated eSIM Direct page
  'products.short_stay': '短期停留计划',
  'products.long_stay': '长期停留计划',
  'products.days': '天数',
  'products.data': '数据量',
  'products.price_label': '价格',
  'products.after_data': '流量用尽后',
  'products.action': '操作',
  'products.days_suffix': '天',
  'products.data_filter': '按数据量筛选',
  'products.days_filter': '按留天数筛选',
  'products.all_data': '所有数据量',
  'products.all_days': '所有停留天数',
  'products.tax': '税费',
  'products.no_products': '没有符合条件的套餐',
  'products.coming_soon': '即将推出...',
  'products.premium_coming_soon': '高级套餐即将推出',
  'products.available': '可用eSIM套餐',
  'checkout.after_data': '数据用尽后',
  'checkout.delivery': '配送',
  'checkout.express_delivery': '30分钟内邮件发送',
  'thankyou.choice_official_site': '前往Choice Hotels Japan官方网站',
  'hero.choice.title': '在日本使用的实惠eSIM',
  'hero.choice.subtitle': '畅享舒适住宿和流畅的网络连接。通过Choice Hotels Japan的原创数据套餐，让商务和休闲更加便捷。',
  'hero.rembrandt.title': '在日本使用的实惠eSIM',
  'hero.rembrandt.subtitle': '畅享舒适住宿和流畅的网络连接。通过Rembrandt酒店的原创数据套餐，让商务和休闲更加便捷。',
  'thankyou.rembrandt_official_site': '前往Rembrandt酒店官方网站',
  'footer.choice_copyright': '© {year} Choice Hotels Japan. 版权所有。',
  'footer.rembrandt_copyright': '© {year} Rembrandt Group. 版权所有。',
  'checkout.express_fee': '快递费：',
  
  // Add new translations
  'checkout.tax_included': '（含税）',
  'products.standard_1day': '标准1天套餐',
  'products.standard_3days': '标准3天套餐',
  'products.standard_7days': '标准7天套餐',
  'products.standard_15days': '标准15天套餐',
  'products.standard_30days': '标准30天套餐',
  'products.standard_60days': '标准60天套餐',
  'products.standard_90days': '标准90天套餐',
  'products.premium_1day': '高级1天套餐',
  'products.premium_3days': '高级3天套餐',
  'products.premium_7days': '高级7天套餐',
  'products.premium_15days': '高级15天套餐',
  'products.premium_30days': '高级30天套餐',
  'products.premium_60days': '高级60天套餐',
  'products.premium_90days': '高级90天套餐',
  'products.after_data_standard_1day': '速度降至128kbps',
  'products.after_data_standard_3days': '速度降至128kbps',
  'products.after_data_standard_7days': '速度降至128kbps',
  'products.after_data_standard_15days': '速度降至128kbps',
  'products.after_data_standard_30days': '速度降至128kbps',
  'products.after_data_standard_60days': '速度降至128kbps',
  'products.after_data_standard_90days': '速度降至128kbps',
  'products.after_data_premium_1day': '速度降至1Mbps',
  'products.after_data_premium_3days': '速度降至1Mbps',
  'products.after_data_premium_7days': '速度降至1Mbps',
  'products.after_data_premium_15days': '速度降至1Mbps',
  'products.after_data_premium_30days': '速度降至1Mbps',
  'products.after_data_premium_60days': '速度降至1Mbps',
  'products.after_data_premium_90days': '速度降至1Mbps',
  
  // Add new translations for express delivery
  'checkout.express_delivery_message': '加急服务：我们将在30分钟内通过电子邮件发送eSIM',
  'checkout.standard_delivery_message': '我们将在24小时内通过电子邮件发送eSIM',
  'checkout.express_delivery_option': '30分钟内接收eSIM（+¥550）',
  
  // Add translations for customer info section
  'checkout.customer_info': '客户信息',
  'checkout.basic_info': '基本信息',
  'checkout.additional_info': '附加信息（可选）',
  'checkout.name': '姓名',
  'checkout.name_placeholder': '例如：张三',
  'checkout.phone': '电话号码',
  'checkout.phone_placeholder': '例如：09012345678',
  'checkout.country': '国籍/居住国',
  'checkout.country_placeholder': '请选择国家',
  'checkout.device_info': '设备信息',
  'checkout.device_info_placeholder': '请选择您的设备',
  'checkout.travel_purpose': '旅行目的',
  'checkout.travel_purpose_placeholder': '请选择您的目的',
  'checkout.marketing_consent': '我同意通过电子邮件接收客户支持、活动和促销信息',
  'checkout.support_info': '用于客户支持目的。',
  
  // Payment button translations
  'checkout.complete_payment': '完成支付',
  'checkout.back': '返回',
  'checkout.tourism': '旅游',
  'checkout.business': '商务',
  'checkout.family': '家庭访问',
  'checkout.education': '留学/教育',
  'checkout.other': '其他',
  
  // Add new translations for checkout section
  'checkout.proceed_to_order': '前往订单',
  'checkout.selected_product': '已选商品',
  'checkout.price': '价格',
  'checkout.proceed_to_checkout': '进入结账流程',
  'checkout.select_product': '请选择商品',
  
  // Add missing proceed to payment key
  'checkout.proceed_to_payment': '前往支付',
  
  // Add new UI element translations
  'checkout.payment': '支付信息',
  'checkout.cardholder_name': '持卡人姓名',
  'checkout.reload_form': '重新加载表单',
  'admin.confirm_purchase': '确认购买',
  'admin.update_data': '更新数据',
};
